import { createContext, useEffect } from 'react';
import { Source } from '@sodamnfoolish/sjc-backend-types/src/api/feed/dto';

import { createStore } from '../../../utils/store';

const tweetTypesStore = createStore<{ [key: string]: { selectedTweetTypes: Set<string>; soundTweetTypes: Set<string> } }>({});

export const TweetTypesContext = createContext(tweetTypesStore);

export const TweetTypesProvider = ({ sources, children }: React.PropsWithChildren<{ sources: Source[] }>) => {
    useEffect(() => {
        const initialTweetTypes: {
            [key: string]: { selectedTweetTypes: Set<string>; soundTweetTypes: Set<string> };
        } = {};

        sources.forEach((source) => {
            const selectedSaved = localStorage.getItem(`selectedTweetTypes_${source.username}`);
            const soundSaved = localStorage.getItem(`soundTweetTypes_${source.username}`);

            initialTweetTypes[source.username] = {
                selectedTweetTypes: selectedSaved ? new Set(JSON.parse(selectedSaved)) : new Set(['tweet', 'retweet', 'reply']),
                soundTweetTypes: soundSaved ? new Set(JSON.parse(soundSaved)) : new Set(['tweet', 'retweet', 'reply']),
            };
        });

        tweetTypesStore.set(initialTweetTypes);
    }, [sources]);

    return <TweetTypesContext.Provider value={tweetTypesStore}>{children}</TweetTypesContext.Provider>;
};
